// 9fbef606107a605d69c0edbcd8029e5d
const blue = {
  10: '#51b4bf',
  50: '#edf5fb',
  100: '#dbebf8',
  300: '#93c5ea',
  500: '#4b9fdd',
  600: '#1ba5e0',
  700: '#3c7fb0',
  800: '#254f6e',
  900: '#162f42',
  1000: '#439ad4',
  1100: '#71c1e6',
  B100: '#00A7E0',
  A100: '#5e9ed6',
  C900: '#003057',
  D100: '#2AA9DD',
  E100: '#164b88',
  G100: '#2e6a91',
  H100: '#254F6E',
  200: '#254f6e',
  1200: '#0023B2',
  1300: '#005d95',
  1400: '#f1f8ff',
  1500: '#88c8ff',
  1600: '#00a8e1',
  1700: '#153258',
  1800: '#d3e9f6',
  1900: '#3979a8',
  2000: '#134064',
  2100: '#003761',
  2200: '#3F81B1',
};

export default blue;
